module.exports = __webpack_public_path__ + "img/sellerjoinin_wait.75d7b8b1.jpg";